// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { LaunchRounded } from '@/constants/hardfin-standard-icons';
import { Link, TypographyVariant } from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props {
  /**
   * The URL to link to.
   */
  href: string;

  /**
   * Applies the theme typography styles. Defaults to "inherit".
   */
  variant?: TypographyVariant;
}

/**
 * A link that opens in a new tab. Stops click propagation to prevent
 * triggering parent click handlers when the link is clicked.
 */
export function ExternalLink(props: PropsWithChildren<Props>) {
  const variant = props.variant ?? 'inherit';

  return (
    <Link
      href={props.href}
      variant={variant}
      display="inline-flex"
      alignItems="center"
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      {props.children}&nbsp;
      <LaunchRounded fontSize="inherit" />
    </Link>
  );
}
